// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-toolbar {
  border-radius: 3px;
  background-color: #011d44;
}
mat-toolbar .menu-button-container {
  display: flex;
  justify-content: center;
  width: 50px;
}
mat-toolbar .menu-button-container .sidenavToggle {
  background-color: #011d44;
  color: #81c0e4;
}
mat-toolbar .menu-button-container .sidenavToggle:hover {
  background-color: #81c0e4;
  color: #011d44;
}
mat-toolbar .header-message {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  height: 100%;
  background-color: var(--color-primary);
  color: #81c0e4;
}
mat-toolbar .header-message a {
  cursor: default;
  color: #81c0e4;
  text-decoration: none;
}
mat-toolbar .log-options {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
mat-toolbar .log-options a {
  text-decoration: none;
  color: #81c0e4;
}
mat-toolbar .log-options a:hover {
  text-decoration: underline;
  text-decoration-color: #81c0e4;
  color: #81c0e4;
}
mat-toolbar .navigation-items {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
}
mat-toolbar .navigation-items :first-child {
  margin-right: 10px;
}
mat-toolbar .navigation-items li {
  padding: 2px 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/header/unlogged-header/unlogged-header.component.scss","webpack://./src/utilities/variables.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,yBCHgB;ADElB;AAEE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AAAJ;AAEI;EACE,yBCVY;EDWZ,cCVa;ADUnB;AACM;EACE,yBCZW;EDaX,cCdU;ADelB;AAIE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,sCAAA;EACA,cC1Be;ADwBnB;AAGI;EACE,eAAA;EACA,cC7Ba;ED8Bb,qBAAA;AADN;AAOE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AALJ;AAOI;EACE,qBAAA;EACA,cC3Ca;ADsCnB;AAMM;EACE,0BAAA;EACA,8BC9CW;ED+CX,cC/CW;AD2CnB;AAYE;EACE,qBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;AAVJ;AAWI;EACE,kBAAA;AATN;AAYM;EACE,gBAAA;AAVR","sourcesContent":["@import \"/src/utilities/variables\";\r\n\r\nmat-toolbar {\r\n  border-radius: 3px;\r\n  background-color: $color_dark_blue;\r\n  .menu-button-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    width: 50px;\r\n    \r\n    .sidenavToggle {\r\n      background-color: $color_dark_blue;\r\n      color: $color_light_blue;\r\n      &:hover {\r\n        background-color: $color_light_blue;\r\n        color: $color_dark_blue;\r\n      }\r\n    }\r\n  }\r\n\r\n  .header-message {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    margin: 0 auto;\r\n    height: 100%;\r\n    background-color: var(--color-primary);\r\n    color: $color_light_blue;\r\n    a {\r\n      cursor: default;\r\n      color: $color_light_blue;\r\n      text-decoration: none;\r\n      &:hover {\r\n      }\r\n    }\r\n  }\r\n\r\n  .log-options {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: flex-end;\r\n    \r\n    a {\r\n      text-decoration: none;\r\n      color: $color_light_blue;\r\n      &:hover {\r\n        text-decoration: underline;\r\n        text-decoration-color: $color_light_blue;\r\n        color: $color_light_blue;\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n\r\n\r\n  .navigation-items {\r\n    list-style-type: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    display: flex;\r\n    :first-child {\r\n      margin-right: 10px;\r\n    }\r\n\r\n      li {\r\n        padding: 2px 5px;\r\n      }\r\n  }\r\n\r\n}\r\n\r\n\r\n","$color_black: #000215;\r\n$color_dark_blue: #011d44;\r\n$color_light_blue: #81c0e4;\r\n$color_purple: #c4c5ea;\r\n$color_white: #fefcf9;\r\n$header_height: 50px;\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
